import * as Yup from "yup";

export const validationSchema = Yup.object({
  period: Yup.object({
    dateFrom: Yup.string().required("La fecha de inicio es requerida"),
    dateTo: Yup.string().required("La fecha de fin es requerida"),
  }),
  uid_partner: Yup.string().required("El partner es requerido"),
});
